(function (global, factory) {
  "use strict";

  var api = factory();

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }

  if (global && global.document) {
    var qa = Object.freeze({
      build: api.BUILD,
      resolveOracle: api.resolveOracle,
    });
    try {
      Object.defineProperty(global, "PotalaKarmaHimalayanPath", {
        configurable: false,
        enumerable: false,
        value: qa,
        writable: false,
      });
    } catch (_error) {
      // A prior copy can exist in the theme editor; initialization remains idempotent.
    }
    api.boot(global.document, global);
  }
})(typeof window !== "undefined" ? window : undefined, function () {
  "use strict";

  var BUILD = "pk-himalayan-gateway-v16-20260730";
  var SEEN_KEY = "pkHimalayanPathSeen:four-scored-self-word-v1";
  var PENDING_KEY = "pkHimalayanPathPending:four-scored-self-word-v1";
  var ANSWER_KEYS = ["landscape", "instinct", "response", "power", "role"];
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function shouldAutoOpen(_seenValue, formResult) {
    return formResult !== "success" && formResult !== "errors";
  }

  function canManualOpen() {
    return true;
  }

  function createState(options) {
    return {
      open: false,
      screen: "entry",
      step: -1,
      answers: {},
      resultId: null,
      journeyId: (options && options.journeyId) || null,
      seen: Boolean(options && options.seen),
    };
  }

  function chooseJourney(journeys, randomValue) {
    var ids = Object.keys(journeys || {}).sort();
    if (!ids.length) return null;
    var normalized = Number.isFinite(randomValue) ? randomValue : Math.random();
    var index = Math.min(ids.length - 1, Math.max(0, Math.floor(normalized * ids.length)));
    return ids[index];
  }

  function createCinematicController(root, global, options) {
    var video = root.querySelector('[data-pk-oracle-cinematic]');
    var poster = root.querySelector('[data-pk-oracle-poster]');
    var media = null, mobile = false, failed = false, revision = 0;
    function isMobile() { return global.matchMedia('(max-width:749px)').matches; }
    function fallback() {
      root.dataset.videoFallback = 'true';
      if (poster) poster.hidden = !poster.src;
      if (video) video.hidden = true;
    }
    function resume() {
      if (!video || failed || options.reducedMotion || global.document.hidden ||
          !options.isOpen() || !video.getAttribute('src')) return;
      var currentRevision = revision;
      try {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {
          if (currentRevision === revision) fallback();
        });
      } catch (_error) { fallback(); }
    }
    function set(nextMedia) {
      if (!nextMedia) return;
      media = nextMedia; mobile = isMobile(); revision += 1;
      var source = mobile && media.mobileMp4 ? media.mobileMp4 : media.mp4;
      var image = mobile && media.mobilePoster ? media.mobilePoster : media.poster;
      root.dataset.responsiveMedia = media.mobileMp4 ? 'true' : 'false';
      root.dataset.videoFallback = 'true';
      root.style.setProperty('--pk-oracle-cinematic-poster', 'url("' + (image || '') + '")');
      if (poster) { poster.src = image || ''; poster.hidden = !image; }
      if (!video) return;
      var retry = failed; failed = false;
      video.muted = true; video.loop = true; video.playsInline = true;
      video.poster = image || ''; video.hidden = false;
      if (options.reducedMotion || !source) {
        video.pause(); video.removeAttribute('src'); video.load(); video.hidden = true;
        return;
      }
      if (video.getAttribute('src') !== source || retry) {
        video.src = source; video.load();
      } else if (video.readyState >= 2 && !video.paused) {
        if (poster) poster.hidden = true;
        root.dataset.videoFallback = 'false';
      }
      resume();
    }
    if (video) {
      video.addEventListener('playing', function () {
        if (!options.isOpen() || global.document.hidden) { video.pause(); return; }
        video.hidden = false;
        if (poster) poster.hidden = true;
        root.dataset.videoFallback = 'false';
      });
      video.addEventListener('waiting', function () {
        if (video.readyState < 2 && poster) poster.hidden = false;
      });
      video.addEventListener('error', function () { failed = true; fallback(); });
    }
    global.addEventListener('resize', function () {
      if (media && media.mobileMp4 && mobile !== isMobile()) set(media);
    });
    global.document.addEventListener('visibilitychange', function () {
      if (global.document.hidden) { if (video) video.pause(); }
      else resume();
    });
    return { set: set, resume: resume, pause: function () { if (video) video.pause(); } };
  }

  function reduceState(state, event) {
    var next = {
      open: state.open,
      screen: state.screen,
      step: state.step,
      answers: Object.assign({}, state.answers),
      resultId: state.resultId,
      journeyId: state.journeyId,
      seen: state.seen,
    };
    if (event.type === "skip") {
      next.open = false;
      next.seen = true;
    } else if (event.type === "result") {
      next.open = true;
      next.screen = "result";
      next.step = 5;
      next.answers = Object.assign({}, event.answers);
      next.resultId = String(event.resultId);
      next.seen = true;
    } else if (event.type === "restart") {
      next.open = true;
      next.screen = "question";
      next.step = 0;
      next.answers = {};
      next.resultId = null;
      next.journeyId = event.journeyId || null;
    }
    return next;
  }

  function createPendingPayload(answers, resultId) {
    return {
      answers: Object.assign({}, answers),
      resultId: String(resultId),
    };
  }

  function resolveOracle(answers, options) {
    if (typeof window === 'undefined' || !window.PotalaKarmaFourPassages) return {status:'unavailable',reason:'scoring_engine_unavailable'};
    return window.PotalaKarmaFourPassages.resolve(answers, options || {});
  }

  function readStorage(storage, key) {
    try {
      return storage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  function writeStorage(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (_error) {
      // Storage can be disabled; the experience still works for this page view.
    }
  }

  function removeStorage(storage, key) {
    try {
      storage.removeItem(key);
    } catch (_error) {
      // Storage can be disabled.
    }
  }

  function parsePending(storage, config) {
    var raw = readStorage(storage, PENDING_KEY);
    if (!raw) return null;
    try {
      var pending = JSON.parse(raw);
      var answerKeys =
        pending && pending.answers && typeof pending.answers === "object"
          ? Object.keys(pending.answers).sort()
          : [];
      var validAnswers =
        answerKeys.join(",") === ANSWER_KEYS.slice().sort().join(",") &&
        ANSWER_KEYS.every(function (key) {
          if (key === 'role') return global.PotalaKarmaFourPassages.validWord(pending.answers[key]);
          return Boolean(
            config.answerLabels[key] &&
              Object.prototype.hasOwnProperty.call(
                config.answerLabels[key],
                pending.answers[key],
              ),
          );
        });
      if (
        !pending ||
        typeof pending !== "object" ||
        !validAnswers ||
        !Object.prototype.hasOwnProperty.call(config.results, String(pending.resultId))
      ) {
        return null;
      }
      return createPendingPayload(pending.answers, pending.resultId);
    } catch (_error) {
      return null;
    }
  }

  function getFocusable(dialog) {
    return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (element) {
      return !element.hidden && !element.closest("[hidden]") && element.getAttribute("aria-hidden") !== "true";
    });
  }

  function formatPrice(cents, global) {
    var amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return "";
    var currency =
      (global.Shopify && global.Shopify.currency && global.Shopify.currency.active) || "USD";
    var locale = global.document.documentElement.lang || "en";
    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
      }).format(amount);
    } catch (_error) {
      return amount.toFixed(2) + " " + currency;
    }
  }

  function uniquenessCopy(dziUnique, deityUnique, soldKinds) {
    soldKinds = soldKinds || [];
    if (soldKinds.length) {
      var remainingUnique =
        (dziUnique && soldKinds.indexOf("dzi") === -1) ||
        (deityUnique && soldKinds.indexOf("deity") === -1);
      return {
        heading: "THE PATH CONTINUES.",
        body: remainingUnique
          ? "One selected piece has found its keeper. Your other selection remains a one-of-a-kind piece while available."
          : "One selected piece has found its keeper. Continue through the related pieces to find the form that meets you now.",
      };
    }
    if (dziUnique && deityUnique) {
      return {
        heading: "ONE PIECE. ONE KEEPER.",
        body:
          "Both pieces selected for your reading are one of a kind, with only one available of each. Once either finds its keeper, that exact piece will not return.",
      };
    }
    if (dziUnique) {
      return {
        heading: "YOUR ONE-OF-A-KIND DZI.",
        body:
          "Your selected Dzi is one of a kind, with only one available. The accompanying deity piece is shown without the ONE OF ONE mark.",
      };
    }
    if (deityUnique) {
      return {
        heading: "YOUR ONE-OF-A-KIND DEITY PIECE.",
        body:
          "Your selected deity piece is one of a kind, with only one available. The accompanying Dzi is shown without the ONE OF ONE mark.",
      };
    }
    return {
      heading: "PIECES SELECTED FOR YOUR PATH.",
      body:
        "These two pieces align with your reading. Availability and any ONE OF ONE status are shown individually on each selection.",
    };
  }

  function initialize(root, global) {
    if (root.dataset.pkOracleInitialized === "true") return;

    var dialog = root.querySelector("[data-pk-oracle-dialog]");
    var launcher = root.querySelector("[data-pk-oracle-launcher]");
    var configNode = root.querySelector("[data-pk-oracle-config]");
    if (!dialog || !launcher || !configNode) return;

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (_error) {
      return;
    }

    var questions = Array.prototype.slice.call(
      root.querySelectorAll('[data-screen="question"]'),
    );
    var screens = Array.prototype.slice.call(root.querySelectorAll("[data-screen]"));
    var entry = root.querySelector('[data-screen="entry"]');
    var resultScreen = root.querySelector('[data-screen="result"]');
    var state = createState({
      seen: readStorage(global.sessionStorage, SEEN_KEY) === "1",
    });
    var isGameRequest = false;
    try {
      isGameRequest =
        new global.URL(global.location.href).searchParams.get("view") === "game";
    } catch (_error) {
      isGameRequest = false;
    }
    var advancing = false;
    var savedFocus = null;
    var savedScroll = 0;
    var bodyStyles = null;
    var htmlHadScrollLockClass = false;
    var bodyHadScrollLockClass = false;
    var progressionTimer = null;
    var renderGeneration = 0;
    var inertedBackground = [];
    var quizFloatingBenefits = [];
    function setQuizFloatingBenefitsHidden(active) {
      if (!active) {
        quizFloatingBenefits.forEach(function(record) {
          if(record.observer)record.observer.disconnect();
          ['display','visibility','pointer-events'].forEach(function(property) {
            var saved=record.styles[property];
            if(saved.value)record.element.style.setProperty(property,saved.value,saved.priority);
            else record.element.style.removeProperty(property);
          });
          record.element.toggleAttribute('inert',record.hadInert);
        });
        quizFloatingBenefits=[];
        return;
      }
      if(quizFloatingBenefits.length)return;
      root.ownerDocument.querySelectorAll('[data-pk-home-floating]').forEach(function(element) {
        var styles={};['display','visibility','pointer-events'].forEach(function(property) {
          styles[property]={value:element.style.getPropertyValue(property),priority:element.style.getPropertyPriority(property)};
        });
        var record={element:element,styles:styles,hadInert:element.hasAttribute('inert')};
        quizFloatingBenefits.push(record);
        function syncFloatingBenefits() {
          var minimized=element.classList.contains('is-minimized');
          ['display','visibility','pointer-events'].forEach(function(property) {
            if(minimized){element.style.setProperty(property,property==='display'?'none':property==='visibility'?'hidden':'none','important');return;}
            var saved=styles[property];
            if(saved.value)element.style.setProperty(property,saved.value,saved.priority);
            else element.style.removeProperty(property);
          });
          element.toggleAttribute('inert',minimized||record.hadInert);
        }
        record.observer=new global.MutationObserver(syncFloatingBenefits);
        record.observer.observe(element,{attributes:true,attributeFilter:['class']});
        syncFloatingBenefits();
      });
    }
    var reducedMotion =
      global.matchMedia && global.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var cinematic = createCinematicController(root, global, {
      reducedMotion: reducedMotion,
      isOpen: function () { return state.open; },
    });

    function emitBgm(type, detail) {
      global.document.dispatchEvent(new global.CustomEvent(type, { detail: detail || {} }));
    }

    function setBackgroundInert(active) {
      if (!active) {
        inertedBackground.forEach(function (record) {
          record.element.toggleAttribute("inert", record.hadInert);
        });
        inertedBackground = [];
        return;
      }
      if (inertedBackground.length) return;

      var current = root;
      while (current && current !== global.document.body) {
        var parent = current.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sibling) {
          if (sibling === current) return;
          if (sibling.matches("[data-pk-bgm], [data-pk-opening-gift]")) return;
          inertedBackground.push({
            element: sibling,
            hadInert: sibling.hasAttribute("inert"),
          });
          sibling.toggleAttribute("inert", true);
        });
        current = parent;
      }
    }

    function setCinematic(media) {
      cinematic.set(media);
    }

    function beginNewJourney() {
      state.journeyId = chooseJourney(config.journeyMedia);
      root.dataset.journey = state.journeyId || "";
      setCinematic(config.journeyMedia[state.journeyId]);
    }

    function markSeen() {
      state.seen = true;
      writeStorage(global.sessionStorage, SEEN_KEY, "1");
    }

    function cancelProgression() {
      if (progressionTimer !== null) {
        global.clearTimeout(progressionTimer);
        progressionTimer = null;
      }
      advancing = false;
    }

    function showScreen(target, focusTarget) {
      screens.forEach(function (screen) {
        var active = screen === target;
        screen.hidden = !active;
        if (active) screen.removeAttribute("inert");
        else screen.setAttribute("inert", "");
      });
      if (!target) return;
      dialog.scrollTop = 0;
      var targetToFocus = focusTarget || getFocusable(target)[0] || target;
      if (!targetToFocus.hasAttribute("tabindex") && targetToFocus === target) {
        targetToFocus.setAttribute("tabindex", "-1");
      }
      global.requestAnimationFrame(function () {
        targetToFocus.focus({ preventScroll: true });
      });
    }

    function resetVisualResult() {
      root.classList.remove("pk-oracle-gateway--result");
      root.style.removeProperty("--pk-oracle-result-background");
      root.style.removeProperty("--pk-oracle-result-position");
      if (state.journeyId && config.journeyMedia) {
        setCinematic(config.journeyMedia[state.journeyId]);
      }
    }

    var musicHome, musicNext;
    function placeMusicControl() {
      var control = global.document.querySelector('[data-pk-bgm]');
      if (!control) return;
      if (state.open && global.matchMedia('(max-width:749px)').matches) {
        if (control.parentNode !== dialog) {
          musicHome = control.parentNode;
          musicNext = control.nextSibling;
          dialog.appendChild(control);
        }
      } else if (musicHome) {
        musicHome.insertBefore(control, musicNext && musicNext.parentNode === musicHome ? musicNext : null);
        musicHome = musicNext = null;
      }
    }
    global.addEventListener('resize', placeMusicControl);

    function openGateway(options) {
      options = options || {};
      cancelProgression();
      emitBgm("pk:bgm:context", { context: "gateway" });
      if (!options.restartEntry && !state.journeyId) beginNewJourney();
      if (!state.open) {
        savedFocus = global.document.activeElement;
        savedScroll = global.scrollY || global.pageYOffset || 0;
        bodyStyles = {
          position: global.document.body.style.position,
          top: global.document.body.style.top,
          left: global.document.body.style.left,
          right: global.document.body.style.right,
          overflow: global.document.body.style.overflow,
          width: global.document.body.style.width,
        };
        htmlHadScrollLockClass =
          global.document.documentElement.classList.contains("pk-oracle-scroll-locked");
        bodyHadScrollLockClass =
          global.document.body.classList.contains("pk-oracle-scroll-locked");
        global.document.documentElement.classList.add("pk-oracle-scroll-locked");
        global.document.body.classList.add("pk-oracle-scroll-locked");
        global.document.body.style.position = "fixed";
        global.document.body.style.top = "-" + savedScroll + "px";
        global.document.body.style.left = "0";
        global.document.body.style.right = "0";
        global.document.body.style.width = "100%";
        global.document.body.style.overflow = "hidden";
      }
      state.open = true;
      placeMusicControl();
      dialog.hidden = false;
      cinematic.resume();
      setBackgroundInert(true);
      setQuizFloatingBenefitsHidden(true);
      root.classList.add("is-open");
      if (options.restartEntry) {
        renderGeneration += 1;
        state.screen = "entry";
        state.step = -1;
        state.answers = {};
        state.resultId = null;
        if (global.PKQuizResultState) global.PKQuizResultState.clear();
        beginNewJourney();
        removeStorage(global.sessionStorage, PENDING_KEY);
        resetVisualResult();
        showScreen(entry);
      } else if (state.screen === "result") {
        showScreen(resultScreen);
      } else if (state.step >= 0) {
        showQuestion(state.step);
      } else {
        showScreen(entry);
      }
    }

    function closeGateway() {
      cancelProgression();
      emitBgm("pk:bgm:store-enter", { context: "store" });
      renderGeneration += 1;
      markSeen();
      state.open = false;
      cinematic.pause();
      placeMusicControl();
      root.classList.remove("is-open");
      dialog.hidden = true;
      setBackgroundInert(false);
      setQuizFloatingBenefitsHidden(false);
      screens.forEach(function (screen) {
        screen.setAttribute("inert", "");
      });
      if (bodyStyles) {
        Object.keys(bodyStyles).forEach(function (property) {
          global.document.body.style[property] = bodyStyles[property];
        });
        global.scrollTo(0, savedScroll);
      }
      if (!htmlHadScrollLockClass) {
        global.document.documentElement.classList.remove("pk-oracle-scroll-locked");
      }
      if (!bodyHadScrollLockClass) {
        global.document.body.classList.remove("pk-oracle-scroll-locked");
      }
      if (launcher && !launcher.hidden && savedFocus !== launcher) launcher.focus();
      else if (savedFocus && typeof savedFocus.focus === "function") savedFocus.focus();
    }

    function enterStoreHome() {
      closeGateway();
      var storeHomeLink = root.querySelector('.pk-oracle__brand > a[href]');
      if (storeHomeLink) global.location.assign(storeHomeLink.href);
    }

    function showQuestion(step) {
      state.step = step;
      state.screen = "question";
      var screen = questions[step];
      var key = ANSWER_KEYS[step];
      screen.querySelectorAll("[data-pk-oracle-option]").forEach(function (button) {
        button.setAttribute(
          "aria-pressed",
          String(button.dataset.option === state.answers[key]),
        );
      });
      var word = screen.querySelector('[data-pk-self-word]');
      if (word) { word.value = state.answers.role || ''; word.setCustomValidity(''); }
      showScreen(screen);
    }

    function fourSignsText(answers) {
      return ANSWER_KEYS.map(function (key) {
        return (key === 'role' ? answers[key] : config.answerLabels[key][answers[key]]);
      }).join(" · ");
    }

    function setText(selector, value) {
      var target = root.querySelector(selector);
      if (target) target.textContent = value || "";
    }

    function renderFourSigns(answers) {
      ANSWER_KEYS.forEach(function (key) {
        setText(
          '[data-sign-value="' + key + '"]',
          (key === 'role' ? answers[key] : config.answerLabels[key][answers[key]]),
        );
      });
    }

    function productSnapshot(handle) {
      return config.productsByHandle[handle] || {
        handle: handle,
        exists: false,
        title: "Selected piece",
        url: "/collections/all",
        image: "",
        price: "",
        priceCents: 0,
        available: false,
        oneOfOne: false,
      };
    }

    function setContactFields(result, answers) {
      var form = root.querySelector("[data-pk-oracle-email] form");
      if (!form) return;
      var dzi = productSnapshot(result.dziProductHandle);
      var deity = productSnapshot(result.deityProductHandle);
      var values = {
        fourSigns: fourSignsText(answers),
        persona: result.persona,
        dzi: result.dziName,
        deity: result.deity,
        dziProduct: dzi.title + " — " + dzi.url,
        deityProduct: deity.title + " — " + deity.url,
      };
      Object.keys(values).forEach(function (key) {
        var input = form.querySelector('[data-contact-field="' + key + '"]');
        if (input) input.value = values[key];
      });
    }

    function addOneOfOneSeal(visual) {
      var seal = global.document.createElement("span");
      seal.className = "pk-oracle__one-seal";
      seal.dataset.oneOfOne = "";
      seal.innerHTML = "<strong>ONE OF ONE</strong>";
      visual.appendChild(seal);
    }

    function addCollectorSeal(visual) {
      var seal = global.document.createElement("span");
      seal.className = "pk-collector-seal pk-collector-seal--compact notranslate";
      seal.dataset.pkCollectorSeal = "";
      seal.setAttribute("aria-label", "Collector's piece");
      seal.setAttribute("translate", "no");
      var top = global.document.createElement("span");
      top.className = "pk-collector-seal__word pk-collector-seal__word--top";
      top.setAttribute("aria-hidden", "true");
      top.textContent = "COLLECTOR";
      var monogram = global.document.createElement("span");
      monogram.className = "pk-collector-seal__monogram";
      monogram.setAttribute("aria-hidden", "true");
      monogram.textContent = "PK";
      var bottom = global.document.createElement("span");
      bottom.className = "pk-collector-seal__word pk-collector-seal__word--bottom";
      bottom.setAttribute("aria-hidden", "true");
      bottom.textContent = "PIECE";
      seal.appendChild(top);
      seal.appendChild(monogram);
      seal.appendChild(bottom);
      visual.appendChild(seal);
    }

    function renderProduct(container, snapshot, label) {
      var article = global.document.createElement("article");
      article.className = "pk-oracle__product";
      article.dataset.productHandle = snapshot.handle;
      var visual = global.document.createElement("div");
      visual.className = "pk-oracle__product-visual";
      var image = global.document.createElement("img");
      image.dataset.productImage = "";
      image.src = snapshot.image || "";
      image.alt = snapshot.title || label;
      visual.appendChild(image);
      if (snapshot.oneOfOne) addOneOfOneSeal(visual);
      if (snapshot.priceCents > 100000) addCollectorSeal(visual);

      var details = global.document.createElement("div");
      var eyebrow = global.document.createElement("small");
      eyebrow.textContent = label;
      var title = global.document.createElement("h4");
      title.dataset.productTitle = "";
      title.textContent = snapshot.title || "Selected piece";
      var availability = global.document.createElement("p");
      availability.dataset.productAvailability = "";
      availability.textContent = snapshot.available
        ? snapshot.oneOfOne
          ? "One available at the time this reading was prepared."
          : "Available now; selectable variations may apply."
        : "Availability is being confirmed.";
      var price = global.document.createElement("p");
      price.className = "pk-oracle__product-price";
      price.dataset.productPrice = "";
      price.textContent = snapshot.price || "";
      var link = global.document.createElement("a");
      link.className = "pk-oracle__product-link";
      link.dataset.productLink = "";
      link.href = snapshot.url || "/collections/all";
      link.textContent = snapshot.oneOfOne
        ? "VIEW THIS ONE-OF-A-KIND PIECE"
        : "VIEW THIS PIECE";
      if (!snapshot.available) link.setAttribute("aria-disabled", "true");
      details.appendChild(eyebrow);
      details.appendChild(title);
      details.appendChild(availability);
      details.appendChild(price);
      details.appendChild(link);
      article.appendChild(visual);
      article.appendChild(details);
      container.replaceChildren(article);
      container.dataset.liveState = "snapshot";
    }

    function applyLiveProduct(container, snapshot, live) {
      var article = container.querySelector(".pk-oracle__product");
      if (!article) return null;
      var title = article.querySelector("[data-product-title]");
      var image = article.querySelector("[data-product-image]");
      var price = article.querySelector("[data-product-price]");
      var availability = article.querySelector("[data-product-availability]");
      var link = article.querySelector("[data-product-link]");
      var visual = article.querySelector(".pk-oracle__product-visual");
      var liveTitle = live.title || snapshot.title;
      var liveImage =
        typeof live.featured_image === "string"
          ? live.featured_image
          : live.featured_image && live.featured_image.src;
      title.textContent = liveTitle;
      image.src = liveImage || snapshot.image || "";
      image.alt = liveTitle;
      price.textContent = formatPrice(
        live.price_min !== undefined ? live.price_min : live.price,
        global,
      ) || snapshot.price;
      link.href = live.url
        ? new URL(live.url, global.location.origin).href
        : snapshot.url;
      article.querySelectorAll("[data-one-of-one]").forEach(function (seal) {
        seal.remove();
      });
      article.querySelectorAll("[data-pk-collector-seal]").forEach(function (seal) {
        seal.remove();
      });
      var livePriceCents = Number(
        live.price_min !== undefined ? live.price_min : live.price,
      );
      if (livePriceCents > 100000) addCollectorSeal(visual);
      var liveUnique = Boolean(
        snapshot.oneOfOne && live.available && live.variants && live.variants.length === 1,
      );
      if (liveUnique) addOneOfOneSeal(visual);
      if (live.available) {
        link.removeAttribute("aria-disabled");
        link.hidden = false;
        link.textContent = liveUnique
          ? "VIEW THIS ONE-OF-A-KIND PIECE"
          : "VIEW THIS PIECE";
        availability.textContent = liveUnique
          ? "One available at the time this reading was refreshed."
          : "Available now; selectable variations may apply.";
      } else {
        link.hidden = true;
        link.setAttribute("aria-disabled", "true");
        availability.textContent =
          "This piece has found its keeper. Explore related pieces instead.";
      }
      container.dataset.liveState = live.available ? "live-available" : "live-sold";
      return { available: Boolean(live.available), unique: liveUnique };
    }

    function refreshProduct(container, snapshot, handle, generation) {
      var rootPath =
        global.Shopify && global.Shopify.routes && global.Shopify.routes.root
          ? global.Shopify.routes.root
          : "/";
      var productUrl;
      if (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) {
        productUrl =
          window.Shopify.routes.root + "products/" + encodeURIComponent(handle) + ".js";
      } else {
        productUrl = rootPath + "products/" + encodeURIComponent(handle) + ".js";
      }
      return global
        .fetch(productUrl, { headers: { Accept: "application/json" } })
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.json();
        })
        .then(function (live) {
          var currentArticle = container.querySelector(".pk-oracle__product");
          if (
            generation !== renderGeneration ||
            !currentArticle ||
            currentArticle.dataset.productHandle !== handle
          ) {
            return { stale: true };
          }
          return applyLiveProduct(container, snapshot, live);
        })
        .catch(function () {
          var currentArticle = container.querySelector(".pk-oracle__product");
          if (
            generation !== renderGeneration ||
            !currentArticle ||
            currentArticle.dataset.productHandle !== handle
          ) {
            return { stale: true };
          }
          container.dataset.liveState = "snapshot-fallback";
          return null;
        });
    }

    function updateOneCopy(dziSnapshot, deitySnapshot, statuses, generation) {
      if (generation !== renderGeneration) return;
      var soldKinds = [];
      if (statuses[0] && !statuses[0].stale && !statuses[0].available) soldKinds.push("dzi");
      if (statuses[1] && !statuses[1].stale && !statuses[1].available) soldKinds.push("deity");
      var dziUnique =
        statuses[0] && !statuses[0].stale
          ? Boolean(statuses[0].unique)
          : Boolean(dziSnapshot.oneOfOne);
      var deityUnique =
        statuses[1] && !statuses[1].stale
          ? Boolean(statuses[1].unique)
          : Boolean(deitySnapshot.oneOfOne);
      var copy = uniquenessCopy(dziUnique, deityUnique, soldKinds);
      setText("[data-one-heading]", copy.heading);
      setText("[data-one-body]", copy.body);
    }

    function renderResult(answers, forcedResultId) {
      if (!state.open) return;
      cancelProgression();
      renderGeneration += 1;
      var generation = renderGeneration;
      var outcome = global.PotalaKarmaFourPassages.resolve(answers);
      if (outcome.status !== 'result' || !config.results[outcome.resultId]) {
        setText('[data-persona]','Your result is temporarily unavailable');
        setText('[data-reading]','Please review your five answers and try again.');
        root.querySelector('[data-original-products]').replaceChildren();
        root.querySelector('[data-original-culture]').replaceChildren();
        showScreen(resultScreen); return;
      }
      var result = config.results[outcome.resultId];
      state = reduceState(state, {
        type: "result",
        answers: answers,
        resultId: result.id,
      });
      markSeen();
      if (global.PKQuizResultState) global.PKQuizResultState.save(answers);
      root.dataset.resultMedia = config.resultMedia[result.id] ? "motion" : "static";
      root.classList.add("pk-oracle-gateway--result");
      setCinematic((config.resultMedia && config.resultMedia[String(result.id)]) || config.neutralResult);
      root.style.setProperty(
        "--pk-oracle-result-background",
        'url("' + result.background + '")',
      );
      root.style.setProperty("--pk-oracle-result-position", result.position || "center");
      setText("[data-persona]", result.persona);
      setText("[data-theme]", result.theme);
      setText("[data-reading]", result.reading);
      setText('[data-result-meaning]', result.resultMeaning);
      setText('[data-result-strength]', result.strength);
      setText('[data-result-blind-spot]', result.blindSpot);
      setText('[data-result-guidance]', result.guidance);
      setText("[data-omen]", config.landscapes[answers.landscape].omen);
      setText("[data-dzi-name]", result.dziName);
      setText("[data-dzi-copy]", result.dziCopy);
      setText("[data-deity-name]", result.deity);
      setText("[data-deity-copy]", result.deityCopy);
      renderFourSigns(answers);
      setText('[data-share-status]', '');
      var shareFallback = root.querySelector('[data-share-fallback]');
      if (shareFallback) shareFallback.hidden = true;
      setContactFields(result, answers);

      showScreen(resultScreen);
      global.document.dispatchEvent(new CustomEvent('pk:oracle-result'));
      global.PKOriginalResults.render(root, result, function(){return generation === renderGeneration && state.screen === 'result';});

    }

    function restartAtQuestion() {
      if (global.PKQuizResultState) global.PKQuizResultState.clear();
      cancelProgression();
      renderGeneration += 1;
      state = reduceState(state, {
        type: "restart",
        journeyId: chooseJourney(config.journeyMedia),
      });
      root.dataset.journey = state.journeyId || "";
      setCinematic(config.journeyMedia[state.journeyId]);
      advancing = false;
      removeStorage(global.sessionStorage, PENDING_KEY);
      resetVisualResult();
      questions.forEach(function (screen) {
        screen.querySelectorAll("[data-pk-oracle-option]").forEach(function (button) {
          button.setAttribute("aria-pressed", "false");
        });
      });
      showQuestion(0);
    }

    root.querySelectorAll("[data-pk-oracle-skip]").forEach(function (button) {
      button.addEventListener("click", enterStoreHome);
    });
    var launcherOpening = false;
    var launcherOpenTimer = null;
    var launcherTransitionDoor = null;
    var launcherTransitionHandler = null;

    function clearLauncherTransition() {
      if (launcherOpenTimer) global.clearTimeout(launcherOpenTimer);
      launcherOpenTimer = null;
      if (launcherTransitionDoor && launcherTransitionHandler) {
        launcherTransitionDoor.removeEventListener(
          "transitionend",
          launcherTransitionHandler,
        );
      }
      launcherTransitionDoor = null;
      launcherTransitionHandler = null;
      launcher.classList.remove("is-opening");
      launcher.removeAttribute("aria-disabled");
    }

    function finishLauncherOpen() {
      if (!launcherOpening) return;
      launcherOpening = false;
      clearLauncherTransition();
      openGateway({ restartEntry: true });
    }

    function beginLauncherOpen() {
      if (launcherOpening) return;
      if (
        global.matchMedia &&
        global.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) {
        openGateway({ restartEntry: true });
        return;
      }
      launcherOpening = true;
      launcher.classList.add("is-opening");
      launcher.setAttribute("aria-disabled", "true");
      launcherTransitionDoor = launcher.querySelector(
        ".pk-oracle-launcher__door--right",
      );
      if (launcherTransitionDoor) {
        launcherTransitionHandler = function (event) {
          if (event.propertyName !== "transform") return;
          finishLauncherOpen();
        };
        launcherTransitionDoor.addEventListener(
          "transitionend",
          launcherTransitionHandler,
        );
      }
      launcherOpenTimer = global.setTimeout(finishLauncherOpen, 1000);
    }

    launcher.addEventListener("click", beginLauncherOpen);
    var start = root.querySelector("[data-pk-oracle-start]");
    if (start) {
      start.addEventListener("click", function () {
        emitBgm("pk:bgm:gateway-start", { context: "gateway" });
        resetVisualResult();
        showQuestion(0);
      });
    }

    var enterStore = root.querySelector("[data-pk-oracle-enter-store]");
    if (enterStore) {
      enterStore.addEventListener("click", enterStoreHome);
    }
    questions.forEach(function (screen, step) {
      screen.querySelectorAll("[data-pk-oracle-option]").forEach(function (button) {
        button.addEventListener("click", function () {
          if (advancing) return;
          advancing = true;
          state = global.PotalaKarmaFourPassages.updateAnswer(state, ANSWER_KEYS[step], button.dataset.option);
          screen.querySelectorAll("[data-pk-oracle-option]").forEach(function (option) {
            option.setAttribute("aria-pressed", String(option === button));
          });
          progressionTimer = global.setTimeout(
            function () {
              progressionTimer = null;
              if (!state.open) {
                advancing = false;
                return;
              }
              if (step === questions.length - 1) renderResult(state.answers);
              else showQuestion(step + 1);
              advancing = false;
            },
            reducedMotion ? 0 : Number(config.progressionDelay || 300),
          );
        });
      });
      var wordForm = screen.querySelector('[data-pk-self-word-form]');
      if (wordForm) {
        var wordInput = wordForm.querySelector('[data-pk-self-word]');
        wordInput.addEventListener('input', function () { wordInput.setCustomValidity(''); state.answers.role = wordInput.value.trim(); });
        wordForm.addEventListener('submit', function (event) {
          event.preventDefault(); if (advancing) return;
          var value = wordInput.value.trim();
          if (!global.PotalaKarmaFourPassages.validWord(value)) { wordInput.setCustomValidity('Please enter one word, up to 40 characters.'); wordInput.reportValidity(); return; }
          wordInput.setCustomValidity('');
          state = global.PotalaKarmaFourPassages.updateAnswer(state, 'role', value);
          renderResult(state.answers);
        });
      }
      var back = screen.querySelector("[data-pk-oracle-back]");
      if (back) {
        back.addEventListener("click", function () {
          if (advancing) return;
          if (step === 0) {
            state.step = -1;
            state.screen = "entry";
            showScreen(entry);
          } else {
            showQuestion(step - 1);
          }
        });
      }
    });
    function readSharedAnswers() {
      try {
        var request = new global.URL(global.location.href);
        if (request.searchParams.get('shared') !== '1') return null;
        var raw = new global.URLSearchParams(request.hash.slice(1)).get('answer');
        if (!raw || raw.length > 1024) return null;
        var source = JSON.parse(raw), answers = {};
        if (!source || typeof source !== 'object' || Array.isArray(source)) return null;
        if (!ANSWER_KEYS.every(function (key) { return typeof source[key] === 'string'; })) return null;
        ANSWER_KEYS.forEach(function (key) { answers[key] = source[key]; });
        var outcome = global.PotalaKarmaFourPassages.resolve(answers);
        return outcome.status === 'result' ? answers : null;
      } catch (_error) { return null; }
    }
    var shareButton = root.querySelector('[data-share-answer]');
    if (shareButton) shareButton.addEventListener('click', async function () {
      if (state.screen !== 'result' || !state.resultId || shareButton.disabled) return;
      var figure = config.results[state.resultId], answers = {};
      ANSWER_KEYS.forEach(function (key) { answers[key] = state.answers[key]; });
      var link = new global.URL('/?view=game&shared=1', global.location.origin);
      link.hash = new global.URLSearchParams({answer: JSON.stringify(answers)}).toString();
      var payload = {title: 'My Potala Karma result: ' + figure.persona, text: figure.persona + ' is my deity archetype.', url: link.href};
      var status = root.querySelector('[data-share-status]');
      var fallback = root.querySelector('[data-share-fallback]');
      status.textContent = ''; fallback.hidden = true; shareButton.disabled = true;
      try {
        if (global.navigator.share) {
          try { await global.navigator.share(payload); status.textContent = 'Share complete.'; return; }
          catch (error) { if (error.name === 'AbortError') return; }
        }
        if (!global.navigator.clipboard || !global.navigator.clipboard.writeText) throw new Error('Copy unavailable');
        await global.navigator.clipboard.writeText(link.href);
        status.textContent = 'Answer link copied.';
      } catch (_error) {
        var input = root.querySelector('[data-share-url]');
        input.value = link.href; fallback.hidden = false; input.focus(); input.select();
        status.textContent = 'Copy the link below to share your answer.';
      } finally { shareButton.disabled = false; }
    });
    root.querySelectorAll("[data-pk-oracle-restart]").forEach(function (restart) {
      restart.addEventListener("click", restartAtQuestion);
    });

    var contactForm = root.querySelector("[data-pk-oracle-email] form");
    if (contactForm) {
      contactForm.addEventListener("submit", function (event) {
        var email = contactForm.querySelector('input[type="email"]');
        if (!email || !email.checkValidity()) {
          event.preventDefault();
          if (email) email.reportValidity();
          return;
        }
        var result = config.results[String(state.resultId)];
        if (!result) {
          event.preventDefault();
          return;
        }
        setContactFields(result, state.answers);
        writeStorage(
          global.sessionStorage,
          PENDING_KEY,
          JSON.stringify(createPendingPayload(state.answers, state.resultId)),
        );
      });
    }

    var headerNav = dialog.querySelector(".pk-oracle__brand");
    if (headerNav) {
      headerNav.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        var openDisclosure = headerNav.querySelector(
          ".pk-oracle__story-disclosure[open]",
        );
        if (!openDisclosure) return;
        event.preventDefault();
        event.stopPropagation();
        var summary = openDisclosure.querySelector("summary");
        openDisclosure.removeAttribute("open");
        if (summary) {
          summary.setAttribute("aria-expanded", "false");
          summary.focus();
        }
      });
    }

    dialog.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeGateway();
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = getFocusable(dialog);
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && global.document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && global.document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    root.dataset.pkOracleInitialized = "true";
    launcher.hidden = false;
    launcher.disabled = false;

    var formResult = root.dataset.formResult || "none";
    var pending =
      formResult === "success" || formResult === "errors"
        ? parsePending(global.sessionStorage, config)
        : null;
    if (pending) {
      openGateway();
      renderResult(pending.answers, pending.resultId);
      global.requestAnimationFrame(function () {
        var status = root.querySelector("[data-email-status]");
        if (status) status.focus({ preventScroll: true });
      });
      if (formResult === "success") removeStorage(global.sessionStorage, PENDING_KEY);
    } else if (formResult === "success" || formResult === "errors") {
      removeStorage(global.sessionStorage, PENDING_KEY);
      dialog.hidden = true;
    } else if (
      isGameRequest &&
      shouldAutoOpen(readStorage(global.sessionStorage, SEEN_KEY), formResult)
    ) {
      var requestParams = new global.URL(global.location.href).searchParams;
      var savedResult = requestParams.get('resume') === 'result' && global.PKQuizResultState
        ? global.PKQuizResultState.read() : null;
      openGateway();
      if (requestParams.get('retake') === '1') restartAtQuestion();
      else if (readSharedAnswers()) renderResult(readSharedAnswers());
      else if (savedResult) renderResult(savedResult.answers, savedResult.resultId);
    }
  }

  function boot(document, global) {
    function initializeAll() {
      document.querySelectorAll("[data-pk-oracle-gateway]").forEach(function (root) {
        initialize(root, global);
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener("shopify:section:load", initializeAll);
  }

  return Object.freeze({
    BUILD: BUILD,
    SEEN_KEY: SEEN_KEY,
    PENDING_KEY: PENDING_KEY,
    boot: boot,
    canManualOpen: canManualOpen,
    createPendingPayload: createPendingPayload,
    createState: createState,
    reduceState: reduceState,
    resolveOracle: resolveOracle,
    shouldAutoOpen: shouldAutoOpen,
    uniquenessCopy: uniquenessCopy,
    chooseJourney: chooseJourney,
    createCinematicController: createCinematicController,
  });
});

